import Auth from "./API/auth.service";
import News from "./API/news.service";
import Meeting from "./API/meeting.service";
import Research from "./API/research.service";
import User from "./API/user.service";
import Budget from "./API/budget.service";
import formRF from "./API/formRF.service";
import ResearchForm from "./API/researchForm.service"
import Common from "./API/common.service";
import FormRL from "./API/formRL.service";
import FormRO from "./API/formRO.service";

export default {
    Auth,
    News,
    Meeting,
    Research,
    User,
    Budget,
    formRF,
    ResearchForm,
    Common,
    FormRL,
    FormRO,
}
